export { default } from './BatchActionsControls';



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsControls/index.js